import styled from '@emotion/styled'
import { navigate } from 'gatsby'
import React, { useState } from 'react'
import BreakPoints from '../../styles/breakPoints'
import CommonInput from './commonInput'

const Wrapper = styled.div`
  max-width: 400px;
  min-width: 220px;
  width: 100%;
  margin: 0 auto 0 10px;
  position: relative;
  display: flex;

  .svg-icon {
    z-index: 1;
    top: 10px;
    right: 5px;
    width: 28px;
    position: absolute;
  }

  .search-input {
    width: 100%;

    input {
      background: #ffffff;
      height: 50px;
      border-radius: 8px 0 0 8px;
      border-right: none;
    }
  }

  ${BreakPoints.medium} {
    min-width: unset;
    font-size: 0.9em;
    width: 260px;
    margin: 0 auto 0 5px;
    left: 10px;
  }

  ${BreakPoints.small} {
    width: 220px;
    left: 0;
    font-size: 0.95em;
  }
`
const Button = styled.button`
  display: inline-flex;
  height: 50px;
  width: 80px;
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  border-radius: 0 8px 8px 0;
  padding: 0 10px;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  background: #19ba9b;
  border: #19ba9b solid 2px;
  border-left: none;
  overflow: hidden;
`

type Props = {
  /** クラス名 */
  className?: string
}

/**
 * 検索フィールド
 * @constructor
 */
const SearchInput = (props: Props): JSX.Element => {
  const { className = '' } = props
  const [search, setSearch] = useState('')
  return (
    <Wrapper className={`${className} search-input-wrap`}>
      <CommonInput
        value={search}
        onChangeValue={setSearch}
        onKeyPress={(e) =>
          e.key === 'Enter' && navigate(`/help/search?word=${search}`)
        }
        className="search-input"
        placeholder="検索キーワードを入力"
      />
      <Button
        className="search-btn"
        onClick={() => navigate(`/help/search?word=${search}`)}
      >
        検索
      </Button>
    </Wrapper>
  )
}

export default SearchInput
